export default "__VITE_ASSET__89bfc6b0__"